import React from 'react';
import Hero from '../../components/Hero';
import Banner, {BottomBanner} from '../../components/Banner';
import Card from '../../components/Card';
import View from '../../components/View';

const Index = () => {
  return (
    <View className="view--index">
      <Hero
        title={(() => (<span>Ищем звёзд: <a className="hero__finding-link" href="https://hh.ru/vacancy/23322790?query=Data%20scientist%20%D0%A1%D0%98%D0%91%D0%A3%D0%A0" target="_blank" rel="noopener noreferrer">Data Scientist</a></span>))()}
        description={(() => (<span>"Порекомендуй друга и получи награду, устраивайся и получай зарплату.<br/>Узнайте <a className="hero__finding-small-link" href="https://hh.ru/vacancy/23322790?query=Data%20scientist%20%D0%A1%D0%98%D0%91%D0%A3%D0%A0" target="_blank" rel="noopener noreferrer">подробнее о вакансии</a> в нашем headhunter</span>))()}
      />
      <Banner text="30 000₽ за рекомендацию"/>
      <div className="app__cards-container">
        <Card
          image={require('./resources/wehire_x1.png')}
          image2x={require('./resources/wehire_x2.png')}
          image3x={require('./resources/wehire_x3.png')}
          title="Мы ищем"
        >
          Аналитиков с опытом реализации проектов в области машинного обучения и искусственного интеллекта. Идеально, если удалось монетизировать, нет — научим. Главное — это аналитический склад ума, любопытство и готовность учиться.
        </Card>
        <Card
          image={require('./resources/whattodo_x1.png')}
          image2x={require('./resources/whattodo_x2.png')}
          image3x={require('./resources/whattodo_x3.png')}
          title="Нужно будет"
        >
          Делать проекты, приносящие реальную пользу, применять свои навыки и знания, улучшая производственные и бизнес-процессы. Участвовать в формировании видения продукта, оглядываясь на бизнес-проблематику, выдвигать гипотезы и проверять их, определять источники данных, применять сложные алгоритмы и инструменты для аналитики.
        </Card>
        <Card
          image={require('./resources/wework_x1.png')}
          image2x={require('./resources/wework_x2.png')}
          image3x={require('./resources/wework_x3.png')}
          title="Работаем"
        >
          В современном офисе рядом с метро «Профсоюзная». Живём по Scrum и пользуемся интегрированными между собой Jira, Confluence и Slack. Используем Python и собственный фреймворк для быстрого ввода моделей в промышленную эксплуатацию.
        </Card>
      </div>
      <iframe
        title="На шаг впереди"
        className="hero__video"
        src="https://www.youtube.com/embed/4Hvab9IPpsY"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen={true}
      />
      <BottomBanner text="Порекомендуй друга и получи награду, устраивайся сам и получай зарплату." />
    </View>
  );
};

export default Index;
